<template>
  <div class="outer">

    <div class="content">
      <div class="agreement">
        <div class="rich-text" v-html="content"/>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Policy",
  data(){
    return {
      content: '<p>《魔方屋未来样板间参观指引和安全免责声明》</p><p><br></p><p>1、为了确保未来样板间的安全使用，全屋24小时提供360度视频监控；</p><p><br></p><p>2、出入样板间请随手关闭入户大门；</p><p><br></p><p>3、严禁在样板间内吸烟、喝酒、打闹、使用洗手间等行为；对危及自己和他人安全的行为、动向，有制止、揭发、汇报的责任；如因以上行为产生的不良后果，由访客自行负责；</p><p><br></p><p>4、严禁随意挪动样板间内各种家具、设施、设备，如因以上行为造成任何损失或人身伤害，需访客自行承担所有后果；</p><p><br></p><p>5、访客不得带走样板间内物品，一旦发现作为偷窃行为报警处理；</p><p><br></p><p>6、访客私人物品请随身携带，如果丢失本公司概不负责；</p><p><br></p><p>7、访客不得在样板间内进行任何非法行为和非法交易，如果发生以上行为均与本公司无关，本公司也不承担任何以上行为造成的任何损失；</p><p><br></p><p>8、本公司仅提供参观场地和物品，访客在样板间内出现任何被动或主动人身伤害或身故，均与本公司无关；</p><p><br></p><p>9、本公司《深圳易道魔方系统科技有限公司&nbsp;》保留对以上内容的最终解释权。</p><p><br></p>',
    }
  },
}
</script>

<style lang="scss" scoped>
.outer{
  position: relative;
  min-height: 100vh;
  min-width: 100vw;
}
.content{
  .agreement{
    background: #fff;
    padding: .3rem .35rem;
    line-height: .45rem;
  }
}
</style>
